import classes from "./reserved-credits-label.module.css";

function ReservedCreditsLabel() {
  return (
    <div className={classes.root}>
      <img
        src="/hire/reserved-label.svg"
        alt="reserved-icon"
        width={12}
        height={12}
        className={classes.reservedIcon}
      />
      Your credits are temporarily reserved while we review your recent job
      posting. Credits will be consumed only when your job is made active. If
      the job gets rejected, these credits will be automatically made available
      for use.
    </div>
  );
}

export default ReservedCreditsLabel;
